<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">
   
   <el-drawer :show-close="false" :visible.sync="$teras.app.drawer" direction="ltr" :size="($teras.app.device=='desktop') ? '480px' : '80%'">
      <siteDrawer></siteDrawer> 
   </el-drawer>

   <div class="header-top" >
      <site-header></site-header>
   </div>

   <div class="app-main row">
      <div id="main" class="col s12 yo-text-center" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->
   
   
   
   <div class="footer-bottom yo-text-normal">
      <site-footer v-if="!(['savethedate'].indexOf($route.name) > -1)"></site-footer>
   </div>   
   
  <!--
    Il nostro sito web utilizza i cookie per assicurarti la miglior esperienza di navigazione. Se desideri maggiori informazioni sui cookie e su come controllarne l'abilitazione con le impostazioni del browser consulta la nostra Cookie Policy
  -->
  
</div> <!-- end app -->
</template>

<script>
import siteDrawer from './components/Site-drawer.vue'
import siteHeader from './components/Site-header.vue'
import siteFooter from './components/Site-footer.vue'
export default {
   name: 'app',
   components: {
      siteDrawer,
      siteHeader,
      siteFooter
   },
   data() {
      return {
         loading:{}
      }
   },
   created(){

      this.$teras.event.on('notify', (titolo,messaggio,tipo) => {
         titolo = (typeof messaggio == 'string') ? titolo : 'Errore non specificato'
         messaggio = (typeof messaggio == 'string') ? messaggio : 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'
         tipo = (typeof tipo == 'string') ? tipo : 'error'
         this.$notify({type: tipo, title: titolo, message: messaggio})
      })

      this.$teras.event.on('loading', (messaggio) => {
         console.log(typeof messaggio)
         messaggio = (typeof messaggio == 'string') ? messaggio : 'Caricamente in corso, non ricaricare la pagina.....'
         console.log("messaggio: "+messaggio)
         this.loading = this.$loading({lock: true, text: messaggio, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      })
      this.$teras.event.on('loadingclose', () => {
         this.loading.close()
      })
   }
}
</script>

<style>
.el-drawer__header {
   display:none !important;
}.el-drawer__body{
   background:#3E69B9;
}
</style>
